module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-clock-hours"
  }, [_c('clock-pointer', {
    attrs: {
      "hasSelected": "",
      "value": _vm.getSelected(),
      "type": "hour"
    }
  }), _vm._v(" "), _vm._l((_vm.hours), function(hour) {
    return _c('clock-number', {
      key: hour,
      attrs: {
        "selected": _vm.getSelected() === hour,
        "type": "hour",
        "value": hour
      }
    })
  }), _vm._v(" "), _c('div', {
    ref: "mask",
    staticClass: "mu-clock-hours-mask",
    on: {
      "mouseup": _vm.handleUp,
      "mousemove": _vm.handleMove,
      "touchmove": _vm.handleTouchMove,
      "touchend": _vm.handleTouchEnd
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-adcdda62"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/timePicker/clockHours.vue
// module id = 471
// module chunks = 1